import { render, staticRenderFns } from "./BackendSelectField.vue?vue&type=template&id=ca5bd7c4&"
import script from "./BackendSelectField.vue?vue&type=script&lang=js&"
export * from "./BackendSelectField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports